import Loader from "./Loader"

function LoadingScreen() {
    return (
        <div className="loading-screen">
            <Loader />
        </div>
    )
}

export default LoadingScreen